/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Area_LumbarInputs */

const en_us2_profile_editors_pain_area_lumbar = /** @type {(inputs: Profile_Editors_Pain_Area_LumbarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lower back`)
};

const pt_br2_profile_editors_pain_area_lumbar = /** @type {(inputs: Profile_Editors_Pain_Area_LumbarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lombar`)
};

const es_419_profile_editors_pain_area_lumbar = /** @type {(inputs: Profile_Editors_Pain_Area_LumbarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zona lumbar`)
};

const pt_pt2_profile_editors_pain_area_lumbar = /** @type {(inputs: Profile_Editors_Pain_Area_LumbarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lombar`)
};

const fr_fr2_profile_editors_pain_area_lumbar = /** @type {(inputs: Profile_Editors_Pain_Area_LumbarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bas du dos`)
};

const de_de2_profile_editors_pain_area_lumbar = /** @type {(inputs: Profile_Editors_Pain_Area_LumbarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterer Rücken`)
};

const it_it2_profile_editors_pain_area_lumbar = /** @type {(inputs: Profile_Editors_Pain_Area_LumbarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zona lombare`)
};

/**
* | output |
* | --- |
* | "Lower back" |
*
* @param {Profile_Editors_Pain_Area_LumbarInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_area_lumbar = /** @type {((inputs?: Profile_Editors_Pain_Area_LumbarInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Area_LumbarInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_area_lumbar(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_area_lumbar(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_area_lumbar(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_area_lumbar(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_area_lumbar(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_area_lumbar(inputs)
	return en_us2_profile_editors_pain_area_lumbar(inputs)
});
export { profile_editors_pain_area_lumbar as "profile-editors.pain_area_lumbar" }